/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssistitoDTO
 */
export interface AssistitoDTO {
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    nome?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    cognome?: string;
    /**
     * 
     * @type {Date}
     * @memberof AssistitoDTO
     */
    dataDiNascita?: Date;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    codiceFiscale?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    sesso?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    nascitaNazioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    nascitaRegioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    nascitaProvinciaId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    nascitaComuneId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    nascitaRegione?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    nascitaProvincia?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    nascitaComune?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    residenzaRegione?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    residenzaProvincia?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    residenzaComune?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    residenzaNazioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    residenzaRegioneId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    residenzaProvinciaId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    residenzaComuneId?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    residenzaIndirizzo?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    residenzaCAP?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    residenzaNumeroCivico?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    telefono?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    cellulare?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    note?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    readonly nomeCompleto?: string;
    /**
     * 
     * @type {string}
     * @memberof AssistitoDTO
     */
    readonly indirizzoResidenzaCompleto?: string;
    /**
     * 
     * @type {boolean}
     * @memberof AssistitoDTO
     */
    hasUserId?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssistitoDTO
     */
    hasAllergie?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssistitoDTO
     */
    hasICE?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssistitoDTO
     */
    hasIntolleranze?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssistitoDTO
     */
    hasMalattie?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssistitoDTO
     */
    hasPatologieInfettive?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssistitoDTO
     */
    hasTerapie?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof AssistitoDTO
     */
    hasTraumi?: boolean;
}

/**
 * Check if a given object implements the AssistitoDTO interface.
 */
export function instanceOfAssistitoDTO(value: object): value is AssistitoDTO {
    return true;
}

export function AssistitoDTOFromJSON(json: any): AssistitoDTO {
    return AssistitoDTOFromJSONTyped(json, false);
}

export function AssistitoDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssistitoDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'nome': json['nome'] == null ? undefined : json['nome'],
        'cognome': json['cognome'] == null ? undefined : json['cognome'],
        'dataDiNascita': json['dataDiNascita'] == null ? undefined : (new Date(json['dataDiNascita'])),
        'codiceFiscale': json['codiceFiscale'] == null ? undefined : json['codiceFiscale'],
        'sesso': json['sesso'] == null ? undefined : json['sesso'],
        'nascitaNazioneId': json['nascita_NazioneId'] == null ? undefined : json['nascita_NazioneId'],
        'nascitaRegioneId': json['nascita_RegioneId'] == null ? undefined : json['nascita_RegioneId'],
        'nascitaProvinciaId': json['nascita_ProvinciaId'] == null ? undefined : json['nascita_ProvinciaId'],
        'nascitaComuneId': json['nascita_ComuneId'] == null ? undefined : json['nascita_ComuneId'],
        'nascitaRegione': json['nascita_Regione'] == null ? undefined : json['nascita_Regione'],
        'nascitaProvincia': json['nascita_Provincia'] == null ? undefined : json['nascita_Provincia'],
        'nascitaComune': json['nascita_Comune'] == null ? undefined : json['nascita_Comune'],
        'residenzaRegione': json['residenza_Regione'] == null ? undefined : json['residenza_Regione'],
        'residenzaProvincia': json['residenza_Provincia'] == null ? undefined : json['residenza_Provincia'],
        'residenzaComune': json['residenza_Comune'] == null ? undefined : json['residenza_Comune'],
        'residenzaNazioneId': json['residenza_NazioneId'] == null ? undefined : json['residenza_NazioneId'],
        'residenzaRegioneId': json['residenza_RegioneId'] == null ? undefined : json['residenza_RegioneId'],
        'residenzaProvinciaId': json['residenza_ProvinciaId'] == null ? undefined : json['residenza_ProvinciaId'],
        'residenzaComuneId': json['residenza_ComuneId'] == null ? undefined : json['residenza_ComuneId'],
        'residenzaIndirizzo': json['residenza_Indirizzo'] == null ? undefined : json['residenza_Indirizzo'],
        'residenzaCAP': json['residenza_CAP'] == null ? undefined : json['residenza_CAP'],
        'residenzaNumeroCivico': json['residenza_NumeroCivico'] == null ? undefined : json['residenza_NumeroCivico'],
        'email': json['email'] == null ? undefined : json['email'],
        'telefono': json['telefono'] == null ? undefined : json['telefono'],
        'cellulare': json['cellulare'] == null ? undefined : json['cellulare'],
        'note': json['note'] == null ? undefined : json['note'],
        'id': json['id'] == null ? undefined : json['id'],
        'nomeCompleto': json['nomeCompleto'] == null ? undefined : json['nomeCompleto'],
        'indirizzoResidenzaCompleto': json['indirizzoResidenzaCompleto'] == null ? undefined : json['indirizzoResidenzaCompleto'],
        'hasUserId': json['hasUserId'] == null ? undefined : json['hasUserId'],
        'hasAllergie': json['hasAllergie'] == null ? undefined : json['hasAllergie'],
        'hasICE': json['hasICE'] == null ? undefined : json['hasICE'],
        'hasIntolleranze': json['hasIntolleranze'] == null ? undefined : json['hasIntolleranze'],
        'hasMalattie': json['hasMalattie'] == null ? undefined : json['hasMalattie'],
        'hasPatologieInfettive': json['hasPatologieInfettive'] == null ? undefined : json['hasPatologieInfettive'],
        'hasTerapie': json['hasTerapie'] == null ? undefined : json['hasTerapie'],
        'hasTraumi': json['hasTraumi'] == null ? undefined : json['hasTraumi'],
    };
}

export function AssistitoDTOToJSON(value?: Omit<AssistitoDTO, 'nomeCompleto'|'indirizzoResidenzaCompleto'> | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'nome': value['nome'],
        'cognome': value['cognome'],
        'dataDiNascita': value['dataDiNascita'] == null ? undefined : ((value['dataDiNascita'] as any).toISOString()),
        'codiceFiscale': value['codiceFiscale'],
        'sesso': value['sesso'],
        'nascita_NazioneId': value['nascitaNazioneId'],
        'nascita_RegioneId': value['nascitaRegioneId'],
        'nascita_ProvinciaId': value['nascitaProvinciaId'],
        'nascita_ComuneId': value['nascitaComuneId'],
        'nascita_Regione': value['nascitaRegione'],
        'nascita_Provincia': value['nascitaProvincia'],
        'nascita_Comune': value['nascitaComune'],
        'residenza_Regione': value['residenzaRegione'],
        'residenza_Provincia': value['residenzaProvincia'],
        'residenza_Comune': value['residenzaComune'],
        'residenza_NazioneId': value['residenzaNazioneId'],
        'residenza_RegioneId': value['residenzaRegioneId'],
        'residenza_ProvinciaId': value['residenzaProvinciaId'],
        'residenza_ComuneId': value['residenzaComuneId'],
        'residenza_Indirizzo': value['residenzaIndirizzo'],
        'residenza_CAP': value['residenzaCAP'],
        'residenza_NumeroCivico': value['residenzaNumeroCivico'],
        'email': value['email'],
        'telefono': value['telefono'],
        'cellulare': value['cellulare'],
        'note': value['note'],
        'id': value['id'],
        'hasUserId': value['hasUserId'],
        'hasAllergie': value['hasAllergie'],
        'hasICE': value['hasICE'],
        'hasIntolleranze': value['hasIntolleranze'],
        'hasMalattie': value['hasMalattie'],
        'hasPatologieInfettive': value['hasPatologieInfettive'],
        'hasTerapie': value['hasTerapie'],
        'hasTraumi': value['hasTraumi'],
    };
}

